import { max } from "@suse-o11y/max";
import { min } from "@suse-o11y/min";

/**
 * A class representing a bidirectional set of numbers.
 * This class allows adding pairs of numbers and checking if a pair exists.
 *
 * @example
 * biSet.add(1, 2).contains(2, 1) -> true
 */
export class NumberBiSet {
	private readonly dict = new Map<number, Set<number>>();

	public add(left: number, right: number): void {
		const minValue = min(left, right);
		const maxValue = max(left, right);

		const others = this.dict.get(minValue) ?? new Set<number>();

		others.add(maxValue);

		this.dict.set(minValue, others);
	}

	public contains(left: number, right: number): boolean {
		const minValue = min(left, right);
		const maxValue = max(left, right);

		return this.dict.get(minValue)?.has(maxValue) ?? false;
	}
}
